var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4 20.6871L14 26.0836L17.6 20.6871H24.8C25.7954 20.6871 26.6 19.883 26.6 18.8883V2.69882C26.6 1.70407 25.7954 0.899994 24.8 0.899994H3.20002C2.20462 0.899994 1.40002 1.70407 1.40002 2.69882V18.8883C1.40002 19.883 2.20462 20.6871 3.20002 20.6871H10.4Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactAlt);
export default __webpack_public_path__ + "static/media/contact-alt.3bedc4d5c80d12a503272833302498ad.svg";
export { ForwardRef as ReactComponent };